import { Type } from '@angular/core';
import { FilterRenderer } from './filter/filter-renderer';

export enum FilterTypes {
  Equal = 'equal',
  EqualNoCase = 'equalnocase',
  Range = 'range',
  Multi = 'multi',
  Group = 'group',
  MultiField = 'multifield',
  /* The next are a set of not yet supported filters, but eventually will be so we keep them here for reference
  Type = 'type',
  GeoDistance = 'geoDistance',
  GeoPolygon = 'geoPolygon',
  MultiOR = 'multiOR',
  MultiNotEqual = 'multiNotEqual',
  NotExist = 'notExist',
  Prefix = 'match_phrase_prefix',
  Stats = 'stats',
  Period = 'period',
  */
}

export interface Filter {
  /**
   * The value of the filter
   */
  key: string;
  /**
   * Header of the title
   */
  value: string;
  /**
   * criteria type: eq, or, range, multi etc
   */
  type: FilterTypes;
  /**
   * Record Attribute
   */
  field: string;

  /**
   * Lookup category source
   */
  lookupCategory?: string;
  /**
   * The selected values of the filter, can be an array, number, string etc
   */
  values?: any;

  /**
   * The selected values of the filter, can be an array, number, string etc
   */
  inputType?: string; // text, number, dropdown, slider, date
  dataType?: string;
  tooltip?: string;
  showLabel?: boolean;
  placeholder?: string;
  disabled?: boolean;
  associations?: Filter[];
  minValue?: number;
  maxValue?: number;
  LabelRenderer?: Type<FilterRenderer>;
}

export interface Aggregation {
  key: string;
  value: number;
  displayName?: string;
}
export interface Aggregations {
  [key: string]: Aggregation[];
}

export interface IOption {
  key?: any;
  value?: string;
  label?: string;
  displayName?: string;
}
